import React from "react";
import { trackEvent } from "@leafly-com/web-utils";
import { NextPage } from "next";
import Head from "next/head";

import faqData from "fixtures/faqData";

import FAQs from "components/FAQ";
import Deals from "components/OnlineOrdering/DealsSection";
import Hero from "components/OnlineOrdering/Hero";
import HowItWorks from "components/OnlineOrdering/HowItWorks";
import LegalMap from "components/OnlineOrdering/LegalMap";
import WantHelp from "components/OnlineOrdering/WantHelp";
import TrackImpression from "components/TrackImpression";
import ValueProps from "components/ValueProps/ValuePropsLite";

const OnlineOrdering: NextPage = () => {
  const fireTrackEvent = () => {
    trackEvent("FAQs", "Click", "Online Ordering FAQs expand/collapse");
  };

  return (
    <>
      <Head>
        <title>Online Ordering | Leafly</title>
        <meta
          name="description"
          content="Order legal marijuana online using Leafly Pickup and Delivery—just like ordering take-out from a restaurant. Here's how to do it on Leafly.com."
        />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=yes"
        />
      </Head>
      <div id="onlineordering" className="online-ordering pb-xxl" role="main">
        <div className="online-ordering__hero bg-green-60">
          <Hero />
        </div>
        <div className="online-ordering__how-it-works bg-white">
          <HowItWorks />
        </div>
        <div className="bg-leafly-white py-section">
          <TrackImpression category="FAQs" label="Online Ordering FAQs">
            <FAQs data={faqData} onEntryClick={fireTrackEvent} />
          </TrackImpression>
        </div>
        <div className="bg-white mx-auto py-section">
          <WantHelp />
        </div>
        <div className="bg-leafly-white online-ordering__deals py-section">
          <Deals title="Deals" page="Online Ordering" />
        </div>
        <div className="my-section container">
          <LegalMap />
        </div>
        <div className="online-ordering__value-props my-section">
          <ValueProps />
        </div>
      </div>
    </>
  );
};

export default OnlineOrdering;
